<template>
  <van-popup
    v-model="visible"
    position="bottom"
    round
    closeable
    close-icon="close"
    style="min-height: 40%;"
  >
    <div class="record">
      <div class="record-title mb_8">
        <p class="mb_12" style="font-size: 20px;">当前幸运值</p>
        <p class="color_red_btn bold" style="font-size: 20px">{{ total }}</p>
      </div>
      <div class="record_list">
        <van-empty
          v-if="noRecord"
          class="custom-image"
          image="https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png"
          description="暂无数据"
        />
        <div v-for="it in list" :key="it.createTime" class="record_item">
          <div class="record_top flex_between mb_8">
            <div class="record_name">{{ it.taskName }}</div>
            <div
              class="record_num bold"
              :class="{
                color_grey: it.credit < 0,
                color_red_btn: it.credit >= 0
              }"
            >{{ it.credit >= 0 ? '+' : '-' }}{{ it.credit }}幸运值</div>
          </div>
          <div class="record_time color_grey fs_12">{{ it.createTime }}</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Empty } from 'vant';
import { getIntegralDetail } from '@/apis/wxActivity'
export default {
  props: {
    activityId: {
      type: String,
      default: '',
    },
    round: {
      type: Number,
      default: 0,
    }
  },
  components: {
    [Popup.name]: Popup,
    [Empty.name]: Empty,
  },
  data () {
    return {
      visible: false,
      list: [],
      noRecord: false,
    }
  },
  computed: {
    total () {
      return this.list.reduce((acc, cur) => acc + cur.credit, 0)
    }
  },
  methods: {
    triggerVisible (visible) {
      this.visible = visible;
      if (visible) {
        this.getList()
      }
    },
    getList () {
      getIntegralDetail({
        activityId: this.activityId,
        round: this.round,
      }).then(res => {
        this.list = res.data
        this.noRecord = !this.list.length
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.record {
  padding: 16px;
  .record_list {
    max-height: 350px;
    overflow: auto;
    padding: 6px 0;
  }
  .record-title {
    padding-bottom: 12px;
    border-bottom: 1px solid #b7b7b7;
  }
  .record_item  + .record_item {
    margin-top: 16px;
  }
}
</style>